// extracted by mini-css-extract-plugin
module.exports = {"PhraseLayout":"PhraseResult_PhraseLayout__YLt1x","Title":"PhraseResult_Title__3N-9y"};